// extracted by mini-css-extract-plugin
export default {"root":"Begin-root-1cea034ed80f1d6f1d4bc38510552f98"};